import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OperatorAdminService } from '../../../services/operator-admin/operator-admin.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// manage an operator's per-user permission overrides (GRANT/DENY on top of the
// role). data = { sumId, name }. Central operator, so establishmentId is null.
@Component({
  selector: 'app-oa-permissions-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './oa-permissions-dialog.component.html',
  styleUrls: ['./oa-permissions-dialog.component.scss', '../../../../common-style/dropdown.scss', '../../../../common-style/ac-dialog.scss'],
})
export class OaPermissionsDialogComponent implements OnInit {
  svpId = new FormControl<number | null>(null);
  effect = new FormControl<'GRANT' | 'DENY'>('GRANT', { nonNullable: true });
  validUntil = new FormControl('');

  catalog: any[] = [];
  overrides: any[] = [];
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<OaPermissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { sumId: number; name: string },
    private operatorAdminService: OperatorAdminService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.loadCatalog();
    this.loadOverrides();
  }

  loadCatalog(): void {
    this.operatorAdminService.listViewPermissions().subscribe({
      next: (res: any) => (this.catalog = res?.data?.viewPermissions || []),
      error: (err) => this.toastService.error(err?.error?.message || 'Failed to load catalog.'),
    });
  }

  loadOverrides(): void {
    this.operatorAdminService.listUserPermissions(this.data.sumId).subscribe({
      next: (res: any) => (this.overrides = res?.data?.overrides || []),
      error: (err) => this.toastService.error(err?.error?.message || 'Failed to load overrides.'),
    });
  }

  add(): void {
    if (!this.svpId.value) {
      this.toastService.error('Select a view-permission.');
      return;
    }
    this.isLoading = true;
    const payload = {
      svpId: this.svpId.value,
      effect: this.effect.value,
      establishmentId: null,
      validUntil: this.validUntil.value || null,
    };
    this.operatorAdminService.setUserPermission(this.data.sumId, payload).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Override saved.');
        this.svpId.setValue(null);
        this.validUntil.setValue('');
        this.isLoading = false;
        this.loadOverrides();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to save override.');
      },
    });
  }

  remove(o: any): void {
    this.isLoading = true;
    this.operatorAdminService.removeUserPermission(this.data.sumId, o.supdId).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Override removed.');
        this.isLoading = false;
        this.loadOverrides();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to remove override.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
